import { useAuth } from 'oidc-react';
import { Link } from 'react-router-dom';
import styles from './Header.module.css';

const Header = () => {
  const isMock = window.name === 'true';
  const auth = isMock ? null : useAuth();
  return (
    <div className={styles.header}>
      <div className={styles.logo}>
        <a href='https://www.shrm.org/' target='_blank' className='mobile-logo'>
          <img src='https://d11p36kvaeudqt.cloudfront.net/logos/SHRMLogo.svg' />
        </a>
      </div>
      {auth?.userData?.profile && (
        <Link to='/signout' className={styles.logout}>
          Log out
        </Link>
      )}
    </div>
  );
};
export default Header;
